import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import { isValidEmail } from 'utils/utils'
import server from 'server/serverController2'

import Presenter from 'components/presenters/signup/SignupEmailScene'
import ScenePaginationFooter from 'components/presenters/footer/ScenePaginationFooter'

export default function EmailFormScene({
  initEmail,
  currSceneNum,
  totalSceneNum,
  onComplete,
  onError,
}) {
  const [emailValue, setEmailValue] = useState('')
  const [emailError, setEmailError] = useState(null)
  const [isValid, setIsValid] = useState(false)

  const checkEmailValid = useMemo(() => {
    if (isValidEmail(emailValue)) {
      setEmailError(null)
      return true
    }

    if (emailValue.length === 0) {
      setEmailError(null)
    } else {
      setEmailError('이메일 형식이 올바르지 않습니다.')
    }

    return false
  }, [emailValue])

  const handleEmailChange = (email) => {
    setEmailValue(email)
  }

  const checkEmailExist = () => {
    return server.getRequestData(`auth/signup/validate?email=${emailValue}`, (res) => {
      try {
        if (res.success !== 1) {
          if (
            res['error']['res_data']['err_code'] === 'DATA_ALREADY_EXISTS' &&
            res['error']['res_data']['detail_code'] === 'EMAIL_ALREADY_EXIST'
          ) {
            setEmailError('이미 존재하는 이메일입니다')
            setIsValid(false)
            return false
          }
        }
        return true
      } catch (err) {
        console.log(err)
      }
    })
  }

  const handleNextScene = async () => {
    const isEmailExist = await checkEmailExist()
    if (isEmailExist && onComplete && isValid) {
      onComplete(emailValue)
    }
  }

  useEffect(() => {
    setIsValid(checkEmailValid)
  }, [checkEmailValid, emailValue])

  useEffect(() => {
    if (initEmail) {
      setEmailValue(initEmail)
    }
  }, [initEmail])

  return (
    <EmailFormWrapper>
      <Presenter onChange={handleEmailChange} email={emailValue} errorMsg={emailError} />
      <ScenePaginationFooter
        totalSceneNum={totalSceneNum}
        currSceneNum={currSceneNum}
        valid={isValid}
        onComplete={handleNextScene}
      />
    </EmailFormWrapper>
  )
}

const EmailFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
